import styled from "styled-components";

import { constants, spacing, theme } from "../../../layout";
import { Caption } from "../../Typography";
import { CSSProperties } from "react";

export const TextInputContainer = styled.div`
  padding: ${spacing.s}px;
  width: 100%;
  box-sizing: border-box;
  background-color: ${theme.input.background};
  border-radius: ${constants.radius.view}px;
`;

export const TextInputComponent = styled.input`
  all: unset;
  width: 100%;
  align-content: stretch;
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 1em;
  font-variation-settings: "slnt" 0;
  &::placeholder {
    color: ${theme.input.placeholder};
  }
`;

export const Container = styled.div`
  flex-grow: 1;
`;

export const Label = styled(Caption)`
  color: ${theme.input.text};
`;

export const ErrorMessage = styled(Caption)`
  color: ${theme.input.error};
`;

export const LeftContainer = styled.div`
  margin-right: ${spacing.xs}px;
`;

export const styles: Record<string, CSSProperties> = {
  disabled: {
    opacity: 0.5,
  },
};
